import { SphereItem } from './sphere_item';
import { CLUSTER_NAME_REGEX } from './shared/constants';
import { isContentOverlayAction, SphereItemType } from 'shared/interfaces/planogram';
import { AppUtils } from './utils/app_utils';
import loadingProgress, { LOADING_STAGES } from './api/services/loading_progress.service';
import { Group } from 'three';
import VideoItem from './video_item';
function fetchVideoAspectRatio(url) {
    const videoElm = document.createElement('video');
    videoElm.preload = 'metadata';
    videoElm.src = url;
    videoElm.load();
    return new Promise(resolve => {
        videoElm.onloadedmetadata = () => {
            videoElm.remove();
            resolve(videoElm.videoWidth / videoElm.videoHeight);
        };
    });
}
export class SphereItems extends Group {
    constructor(planogram, lodProvider) {
        super();
        this.planogram = planogram;
        this.items = [];
        this.layers.enable(2);
        this.items = this.planogram.items.map(item => {
            if (item.type === SphereItemType.Video)
                return new VideoItem(item, this.planogram, lodProvider);
            else
                return new SphereItem(item, this.planogram, lodProvider);
        });
        this.items.forEach(it => this.add(it.object3D));
        loadingProgress.progressStage(LOADING_STAGES.ITEM_MESHES, 1);
    }
    dispose() {
        this.items.forEach(it => it.dispose());
    }
    findClusterByClusterName(clusterName) {
        // handle case with raw value as cluster name
        if (clusterName.match(CLUSTER_NAME_REGEX)) {
            clusterName = AppUtils.extractClusterName(clusterName);
        }
        const foundClusters = this.items.filter(item => {
            return item.data.clusterLink === clusterName && item.type === SphereItemType.Cluster;
        });
        if (foundClusters.length) {
            if (foundClusters.length > 1) {
                console.error('There are more than one cluster with the same name');
            }
            return foundClusters[0];
        }
    }
    findSphereItemByIdentifier(identifier) {
        return this.items.find(item => {
            var _a;
            return item.identifier === identifier || ((_a = item.id) === null || _a === void 0 ? void 0 : _a.toString()) === identifier;
        });
    }
    findSphereItemByActionIdentifier(identifier) {
        return this.items.find(item => {
            var _a;
            return item.identifier === identifier || ((_a = item.id) === null || _a === void 0 ? void 0 : _a.toString()) === identifier;
        });
    }
    findSphereItemByImageId(imageId) {
        return this.items.find(item => {
            var _a, _b, _c, _d;
            return ((_b = (_a = item.data.picture) === null || _a === void 0 ? void 0 : _a.id) === null || _b === void 0 ? void 0 : _b.toString()) === imageId ||
                ((_c = item.data.id) === null || _c === void 0 ? void 0 : _c.toString()) === imageId ||
                ((_d = item.id) === null || _d === void 0 ? void 0 : _d.toString()) === imageId;
        });
    }
    findSphereItemByContentLink(link) {
        return this.items.find(it => it.action !== undefined && isContentOverlayAction(it.action) && it.action.data.iframeLink === link);
    }
}
